import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import './assets/css/style.css'
import utilsCommon from '../src/utils/common'
import Mint from 'mint-ui'

Vue.use(Mint)
Vue.use(Vuex)

import { Uploader, RadioGroup, Radio } from 'vant'
Vue.use(Uploader)
Vue.use(Radio)
Vue.use(RadioGroup)

Vue.prototype.utilsCommon = utilsCommon

/*
  路由发生变化修改页面title
  to.meta 是在路由自定义的参数
  meta: {index: 1, title: '稻草人旅行优惠券'},
*/
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.config.productionTip = false
// 默认头像 用户中心首页 前往会员页面 用户信息页面 会员页面信息.
Vue.prototype.$userlogo = '//dao-library.54traveler.com/dcr-user/user.png'

// 背景图片 邮箱注册 忘记密码 注册登陆 页面
Vue.prototype.$bgimgs = [
  'https://dao-library.54traveler.com/dcr-common/login-bg/bg-six.jpg',
  'https://dao-library.54traveler.com/dcr-common/login-bg/bg-one.jpg',
  'https://dao-library.54traveler.com/dcr-common/login-bg/bg-two.jpg',
  'https://dao-library.54traveler.com/dcr-common/login-bg/bg-three.jpg',
  'https://dao-library.54traveler.com/dcr-common/login-bg/bg-four.jpg',
  'https://dao-library.54traveler.com/dcr-common/login-bg/bg-five.jpg',
  'https://dao-library.54traveler.com/dcr-common/login-bg/bg-six.jpg',
  'https://dao-library.54traveler.com/dcr-common/login-bg/bg-six.jpg'
]

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js